import { ConnectedRouter } from 'connected-react-router';
import React, { useEffect } from 'react';
import { Provider, useSelector } from 'react-redux';

import '@fontsource/rubik';
import { AuthProvider } from '../lib/authContext';
import { currentPathSelector } from '../reducers/selectors';
import Routes from '../routes';
import store, { history } from '../store';
import useGoogleAnalytics from '../useGoogleAnalytics';

import ErrorModal from './ErrorModal';
import Header from './Header';
import MainContainerApp from './LandingPage';
import MainNavigation from './MainNavigation';
import NISOZendesk from './NISOZendesk';
import SignedOutErrorModal from './SignedOutErrorModal';

const { PUBLIC_URL } = process.env;

const App = () => {
  const pathname = useSelector(currentPathSelector);
  const restrictedPathNames = ['/submit', '/successful-submission', '/platform-restart'];
  const showMainNavigation = restrictedPathNames.indexOf(pathname) === -1;
  useGoogleAnalytics();

  useEffect(() => {
    window.onpopstate = () => {
      const magicurl = window.location.pathname.replace(PUBLIC_URL, '');
      history.push(magicurl);
    };
  });

  return (
    <div className="page-wrapper">
      <header>
        <MainNavigation>
          <Header />
        </MainNavigation>
      </header>
      <main className="main niso-container">
        <MainContainerApp showMainNavigation={showMainNavigation} Routes={Routes} />
      </main>
      <ErrorModal />
      <NISOZendesk />
      <SignedOutErrorModal />
    </div>
  );
};

const ConnectedApp = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </AuthProvider>
    </Provider>
  );
};

export default ConnectedApp;
